app.controller('MasterController', [
    '$rootScope', '$scope',
    'SiteShared', 'SiteService', 'MenuService', 'TrackingService',
    'AccountService', 'CurrencyService',

    'AcquiredService', 'ColourService', 'StyleService',
    'ProductService',
    'ProductCabinetKitchenService', 'ProductCabinetBedroomService', 'ProductCurvedService', 'ProductDoorService', 'ProductDoorSlopingCalculatorService',
    'ProductHettichService', 'ProductPanelService', 'ProductSolutionService', 'ProductStockService', 'ProductWrapService',
    'FilterService', 'MatrixProductService',
    'OptionTermService', 'OptionProductService',
    'BrowseService',
    'AssemblyService', 'ClicboxColourService', 'CollectionProductService', 'ColourRouteService', 'ComponentService',
    'DoorTypeService', 'EdgeOptionService', 'HandleColourService', 'IndividualProductService', 'InfoService', 'MethodInputService', 'MethodProductService',
    'RangeInfoService', 'RoomService', 'SelectService', 'SiteRangeService', 'SolutionService', 'StyleRouteService',
    'TabService', 'TileService',

    'CacheBrowseService', 'CacheLocalServerService', 'CacheSettingsService',
    'AdvertService', 'ImageService',
    'DataApiService',
    'OrderEditService', 'OrderHelper', 'OrderHistoryService', 'OrderQuoteService', 'OrderReplacementService', 'OrderService',
    'StaffCustomerService', 'StaffOrderReplacementService', 'StaffService',
    'SupportService',

    '$sce',

    function (
        $rootScope, $scope,
        SiteShared, SiteService, MenuService, TrackingService,
        AccountService, CurrencyService,
        AcquiredService, ColourService, StyleService,
        ProductService,
        ProductCabinetKitchenService, ProductCabinetBedroomService, ProductCurvedService, ProductDoorService, ProductDoorSlopingCalculatorService,
        ProductHettichService, ProductPanelService, ProductSolutionService, ProductStockService, ProductWrapService,
        FilterService, MatrixProductService,
        OptionTermService, OptionProductService,
        BrowseService,
        AssemblyService, ClicboxColourService, CollectionProductService, ColourRouteService, ComponentService,
        DoorTypeService, EdgeOptionService, HandleColourService, IndividualProductService, InfoService, MethodInputService, MethodProductService,
        RangeInfoService, RoomService, SelectService, SiteRangeService, SolutionService, StyleRouteService,
        TabService, TileService,
        CacheBrowseService, CacheLocalServerService, CacheSettingsService,
        AdvertService, ImageService,
        DataApiService,
        OrderEditService, OrderHelper, OrderHistoryService, OrderQuoteService, OrderReplacementService, OrderService,
        StaffCustomerService, StaffOrderReplacementService, StaffService,
        SupportService,

        $sce

    ) {

        const siteShared = SiteShared

        siteShared.addServices({

            site: SiteService,
            menu: MenuService,
            tracking: TrackingService,

            account: AccountService,
            currency: CurrencyService,

            acquired: AcquiredService,
            colour: ColourService,
            style: StyleService,
            product: ProductService,

            product_cabinet_kitchen: ProductCabinetKitchenService,
            product_cabinet_bedroom: ProductCabinetBedroomService,
            product_curved: ProductCurvedService,
            product_door: ProductDoorService,
            product_door_sloping_calculator: ProductDoorSlopingCalculatorService,
            product_hettich: ProductHettichService,
            product_panel: ProductPanelService,
            product_solution: ProductSolutionService,
            product_stock: ProductStockService,
            product_wrap: ProductWrapService,

            filter: FilterService,
            matrix_product: MatrixProductService,

            option_product: OptionProductService,
            option_term: OptionTermService,

            browse: BrowseService,
            assembly: AssemblyService,
            clicbox_colour: ClicboxColourService,
            collection_product: CollectionProductService,
            colour_route: ColourRouteService,
            component: ComponentService,
            door_type: DoorTypeService,
            edge_option: EdgeOptionService,
            handle_colour: HandleColourService,
            individual_product: IndividualProductService,
            info: InfoService,
            method_input: MethodInputService,
            method_product: MethodProductService,
            range_info: RangeInfoService,
            room: RoomService,
            select: SelectService,
            site_range: SiteRangeService,
            solution: SolutionService,
            style_route: StyleRouteService,
            tab: TabService,
            tile: TileService,

            cache_browse: CacheBrowseService,
            cache_local_server: CacheLocalServerService,
            cache_settings: CacheSettingsService,

            advert: AdvertService,
            image: ImageService,

            data_api: DataApiService,

            order_edit: OrderEditService,
            order_helper: OrderHelper,
            order_history: OrderHistoryService,
            order_quote: OrderQuoteService,
            order_replacement: OrderReplacementService,
            order: OrderService,

            staff_customer: StaffCustomerService,
            staff_order_replacement: StaffOrderReplacementService,
            staff: StaffService,

            support: SupportService
        });

        siteShared.populateModelsAndFactories();

        siteShared.triggerMasterInit();

        $scope.uCanTrust = function(string){
            return $sce.trustAsHtml(string);
        }
}]);